import script from "./FramePage.vue?vue&type=script&setup=true&lang=js"
export * from "./FramePage.vue?vue&type=script&setup=true&lang=js"

import "./FramePage.vue?vue&type=style&index=0&id=639cc30b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-639cc30b"]])

export default __exports__